type PayRes = {
  /**
   * 200 =>成功
   * 300 =>等待
   * 500 =>失败
   */
  code: number;
  msg: string;
  title?: string;
  url?: string;
};

export class PayType {
  static WECHAT = 'wechat';
  static ALIPAY = 'alipay';
  static YUNHUITENG = 'yunhuiteng';
  static LFT = 'lft';
}

export async function payOrder(payType: string, data: any) {
  if (payType === PayType.WECHAT) {
    return wechatJsPay(data);
  } else if (payType === PayType.ALIPAY) {
    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.aliPayParam,
    };
  } else if (payType === PayType.YUNHUITENG) {
    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.yunHuiTengPayUrl,
    };
  } else if (payType === PayType.LFT) {
    return {
      code: 300,
      msg: '正在支付',
      title: '收银台',
      url: data.lftPayUrl,
    };
  }
  return {
    code: 500,
    msg: '暂不支持该支付方式',
  };
}

function wechatJsPay(data: any) {
  return new Promise<PayRes>((resolve, reject) => {
    // @ts-ignore
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: data.appid, //动态获取初始化请求中返回的pay_info参数中appId值
        timeStamp: data.timestamp, //动态获取初始化请求中返回的pay_info参数中timeStamp值
        nonceStr: data.noncestr, //动态获取初始化请求中返回的pay_info参数中nonceStr值
        package: data.packageValue, //动态获取初始化请求中返回的pay_info参数中package值
        signType: data.signtype, //动态获取初始化请求中返回的pay_info参数中signType值
        paySign: data.paysign,
      },

      function (res: any) {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          resolve({ code: 200, msg: '支付成功' });
        } else {
          resolve({ code: 500, msg: '支付失败' });
        }
      }
    );
  });
}
